import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {Modal} from 'shells/modal/modal';
import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';
import {OnboardingPage} from 'shells/onboarding-page/onboarding-page';

import styles from './onboarding-modal-company-types.module.css';

type Props = {
    isOpen: boolean;
    onClose: () => void;
};

export class OnboardingModalCompanyTypes extends React.PureComponent<Props> {
    render() {
        return (
            <Modal
                onClose={this.props.onClose}
                canClickOutsideToClose={true}
                closeButton={false}
                isOpen={this.props.isOpen}
                noPadding={true}
                maxHeight={500}
            >
                <OnboardingPage
                    type='singlePage'
                    buttonText='Let’s do this'
                    artImage={<Art />}
                    bodyComponent={<Body />}
                    artBackgroundColor={colors.plum}
                    onClose={this.props.onClose}
                />
            </Modal>
        );
    }
}

const Body = () => (
    <OnboardingBody title='Automatically set company types when leads are closed'>
        <div>
            <p>
                Nutshell supports company types to recognize the different companies you work with.
                For example, you might track <i>Potential customer</i>, <i>Supplier</i>,{' '}
                <i>Reseller</i> and <i>Customer</i>.
            </p>
            <p>
                {' '}
                When a lead is won, you might ask Nutshell to automatically set{' '}
                <i>Potential customer</i> to <i>Customer</i>, so you can easily segment your list of
                businesses.
            </p>
        </div>
    </OnboardingBody>
);

const Art = () => (
    <div className={styles.art}>
        <img src='/include/images/sales-automation/company-type-onboarding.png' />
    </div>
);
